import ProviderApi from '../services/providers/provider.api'

const provider = JSON.parse(localStorage.getItem('provider'))
const initialState = provider
  ? { provider }
  : { provider: null }

export const providerStore = {
  namespaced: true,
  state: initialState,
  actions: {
    load({ commit }) {
      return ProviderApi.getDetail().then(
        provider => {
          commit('loadSuccess', provider)
          return Promise.resolve(provider)
        },
        error => {
          commit('loadFailure')
          return Promise.reject(error)
        }
      )
    }
  },
  mutations: {
    loadSuccess(state, provider) {
      state.provider = provider
    },
    loadFailure(state) {
      state.provider = null
    }
  }
}
